var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25079 16.2145C5.57631 15.9051 3.5 13.6326 3.5 10.8752C3.5 7.90656 5.90656 5.5 8.87521 5.5C11.6327 5.5 13.9052 7.57633 14.2145 10.2508C14.4455 10.2502 14.6894 10.2502 14.9475 10.2502H15.3033C15.4473 10.2502 15.587 10.2502 15.7224 10.2503C15.4067 6.74609 12.4616 4 8.87521 4C5.07814 4 2 7.07814 2 10.8752C2 14.4616 4.74607 17.4067 8.25029 17.7224C8.25018 17.587 8.25018 17.4473 8.25018 17.3033V16.9476C8.25018 16.6894 8.25018 16.4455 8.25079 16.2145Z",
    fill: "#3A3A3A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.46484,
    y: 10.4648,
    width: 12.7861,
    height: 12.7861,
    rx: 2.82154,
    stroke: "#3A3A3A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareHeader);
export default __webpack_public_path__ + "static/media/CompareHeader.179a9a88bf5e85a5a7256003068172eb.svg";
export { ForwardRef as ReactComponent };